// eslint-disable-next-line

import SectionHero from "components/SectionHero/SectionHero";
import SectionOurFeatures from "components/SectionOurFeatures/SectionOurFeatures";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import SectionHowItWork from "components/SectionHowItWork/SectionHowItWork";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
// import { TaxonomyType } from "data/types";
import { Helmet } from "react-helmet";
import SectionBlog from "components/SectionBlog/SectionBlog";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { RootStore } from "functions/redux/store";
import { getCountries, getFeaturedCountries, getHomeCountries } from "functions/redux/country/action";
import CountriesSection from "components/Home/CountriesSection";
import Skeleton from "react-loading-skeleton";
import { checkLogin, getFullCreds } from "functions/redux/user/action";
import { useTranslation } from "react-i18next";
import ButtonPrimary from "shared/Button/ButtonPrimary";

function PageHome() {
  const dispatch = useDispatch();
  const { countriesReducer, user } = useSelector((state: RootStore) => state);
  const countries: any[] = countriesReducer.homeCountries;
  const { t } = useTranslation();
  React.useEffect(() => {
    if (countries == null) {
      dispatch(getHomeCountries());
    }
  }, [countries]);


  // React.useEffect(() => {
  //   if (user.credential == null) {
  //     // checkLogin();
  //     dispatch(checkLogin());
  //   }
  // }, [user])


  return (
    <div className="nc-PageHome relative overflow-hidden">
      <Helmet>
        <title>GuideSantai</title>
      </Helmet>
      <BgGlassmorphism />
      <div className="container relative space-y-8 md:mb-24 lg:space-y-32 lg:mb-32">
        <SectionHero className="pt-2 xl:pt-28" />
        {countries != null ?
          <CountriesSection
            categories={countries}
            heading={t('destination_heading')}
            subHeading={t('destination_subheading')}
          />
          :
          <div className="lg:space-y-32 ">
            <Skeleton height={350} className="mt-8 mb-8" />
          </div>}


        <div className="relative py-16">
          <SectionGridFeaturePlaces
            heading={t('featured_trip')}
            subHeading={t('featured_trip_desc')}
          />
        </div>
        <div className="relative" style={{ marginTop: 50 }}>
          <BackgroundSection />
          <div className="nc-SectionGridFeaturePlaces relative py-16 flex space-x-1">
            <div className=" flex justify-center md:w-40 mr-3">
              <img src="/images/people.png" alt="people" />
            </div>
            <div>
              <h3 className="text-xl md:text-3xl font-semibold mb-2">{t('request_guide_home_desc')}</h3>
              <ButtonPrimary href='/request-guide'>{t('request_guide')}</ButtonPrimary>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default PageHome;
